import type {
  ExperienceModerationDto,
  ExperienceModerationRequestDto,
  ExperienceStatus,
  Page,
  PageQuery,
} from '@kardume/types';
import api from './http';

/**
 * Fila de moderação de experiências do Kardume Interno (card #352).
 *
 * Cliente próprio, e não mais um bloco no `backofficeApi`: aquele arquivo já
 * passou de 1.400 linhas atendendo dezoito domínios, e o de experiências vai
 * crescer com a área (vitrine, relatório, curadoria). Manter o domínio inteiro
 * num arquivo só também deixa cada card tocar apenas o que é dele.
 *
 * Base: `/v1/backoffice/experiences` - `BackofficeExperienceController`.
 */
export const backofficeExperienceApi = {
  /**
   * Fila paginada. `query` casa por título **ou** nome da loja; `status` filtra
   * a etapa do ciclo de vida (a tela abre em `PENDING_REVIEW`).
   */
  list(
    query?: PageQuery & { status?: ExperienceStatus }
  ): Promise<Page<ExperienceModerationDto>> {
    return api
      .get<Page<ExperienceModerationDto>>('/v1/backoffice/experiences', {
        params: {
          page: query?.page ?? 0,
          size: query?.size ?? 20,
          ...(query?.sort ? { sort: query.sort } : {}),
          ...(query?.query ? { query: query.query } : {}),
          ...(query?.status ? { status: query.status } : {}),
        },
      })
      .then((r) => r.data);
  },

  detail(experienceId: string): Promise<ExperienceModerationDto> {
    return api
      .get<ExperienceModerationDto>(`/v1/backoffice/experiences/${experienceId}`)
      .then((r) => r.data);
  },

  /**
   * Aprova ou recusa. A recusa **exige** `rejectionReason`: o core devolve
   * `EXPERIENCE_REJECTION_REASON_REQUIRED` sem ele, e só o que está
   * `PENDING_REVIEW` pode ser julgado (`EXPERIENCE_NOT_PENDING_REVIEW`).
   */
  moderate(
    experienceId: string,
    payload: ExperienceModerationRequestDto
  ): Promise<ExperienceModerationDto> {
    return api
      .post<ExperienceModerationDto>(`/v1/backoffice/experiences/${experienceId}/moderate`, payload)
      .then((r) => r.data);
  },
};
